/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Section_AdvancedInputs */

const cs_property_section_advanced = /** @type {(inputs: Property_Section_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikování`)
};

const en_property_section_advanced = /** @type {(inputs: Property_Section_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing`)
};

/**
* | output |
* | --- |
* | "Publishing" |
*
* @param {Property_Section_AdvancedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_section_advanced = /** @type {((inputs?: Property_Section_AdvancedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Section_AdvancedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_section_advanced(inputs)
	return cs_property_section_advanced(inputs)
});